import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { CEP_BULK_PROCESSING_FORM_NAME, InputMode } from 'Common/FormEnum';
import { CEPBulkProcessingFieldEnum as Fields } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { DatePickerField } from 'Common/SemanticWrapper';

import 'Styles/pages/cepbulkprocessing/index.less';

class CEPBulkProcessingFormContainer extends Component {
  mealTypeOptions = [
    { value: 0, label: 'Breakfast' },
    { value: 1, label: 'Lunch' },
  ];

  handleParticipationChange = e => {
    if (this.props.loadingTotalParticipation) {
      e.preventDefault();
    }
  };

  render() {
    const {
      loading,
      mealTypeOnChange,
      loadingReimbursableItems,
      hasBeenProcessed,
      reimbursableItems,
      sites,
      shouldFormLock,
      loadingTotalParticipation,
    } = this.props;
    const currentDate = moment();
    return (
      <Fragment>
        <Form
          name={CEP_BULK_PROCESSING_FORM_NAME}
          className="cep-bulk-processing-container"
        >
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Field
                  label={'Sites'}
                  name={Fields.Site}
                  component={SelectField}
                  disabled={loading}
                  options={sites}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row cols={3}>
              <Grid.Column width={4}>
                <Field
                  label={'Date'}
                  name={Fields.ServingDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={currentDate}
                  maxDate={currentDate}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column className="input-group--btn-group" width={4}>
                <ReduxFormButtonGroup
                  label={'Meal Type'}
                  formName={CEP_BULK_PROCESSING_FORM_NAME}
                  options={this.mealTypeOptions}
                  fieldName={Fields.MealType}
                  disabled={loading || shouldFormLock}
                  onChange={mealTypeOnChange}
                  showOnlyTouchedError
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={Fields.ReimbursableItem}
                  component={SelectField}
                  options={reimbursableItems}
                  label={'Reimbursable Item'}
                  disabled={
                    loading ||
                    loadingReimbursableItems ||
                    hasBeenProcessed ||
                    shouldFormLock
                  }
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <Field
                  name={Fields.TotalParticipation}
                  component={InputField}
                  label={'Total Participation'}
                  disabled={loading || hasBeenProcessed || shouldFormLock}
                  onChange={this.handleParticipationChange}
                  loading={loadingTotalParticipation}
                  mode={InputMode.Integer}
                  maxLength={5}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={Fields.FreeMeals}
                  component={InputField}
                  label={'Free'}
                  disabled={true}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <Field
                  name={Fields.PaidMeals}
                  component={InputField}
                  label={'Paid'}
                  disabled={true}
                  mode={'text'}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const now = moment();
  const errors = {};
  if (!moment(values[Fields.ServingDate]).isValid()) {
    errors[Fields.ServingDate] = 'Enter a valid Date.';
  }
  if (moment(values[Fields.ServingDate]).isAfter(now)) {
    errors[Fields.ServingDate] = 'Future date is not permitted.';
  }
  if (!values[Fields.ServingDate]) {
    errors[Fields.ServingDate] = 'Date must be set.';
  }
  if (
    !values[Fields.ReimbursableItem] &&
    values[Fields.ReimbursableItem] !== 0
  ) {
    errors[Fields.ReimbursableItem] = 'Reimbursable Item must be set.';
  }
  if (!values[Fields.MealType] && values[Fields.MealType] !== 0) {
    errors[Fields.MealType] = 'Meal Type must be set.';
  }
  if (!values[Fields.TotalParticipation]) {
    errors[Fields.TotalParticipation] = 'Total Participation must be set.';
  }
  if (!values[Fields.Site] && values[Fields.Site] !== 0) {
    errors[Fields.Site] = 'A site must be selected.';
  }
  return errors;
};

export const CEPBulkProcessingForm = reduxForm({
  form: CEP_BULK_PROCESSING_FORM_NAME,
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false,
})(withRouter(connect()(CEPBulkProcessingFormContainer)));



// WEBPACK FOOTER //
// ./src/pages/cepbulkprocessing/components/CEPBulkProcessingForm.js